import { useEffect, useState, useRef } from 'react';
import { CacheProvider } from '@emotion/react';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import { getMUICache, getUrl, getEndpoint, getImageUrl, getImageSize, convertEpochTime, setCookie, getCookie, isLoggedIn } from '../../../common/utils';
import './QuizShow.css'; // Make sure to include the CSS file
import bcrypt from 'bcryptjs-react';
import { PAGEBUILDER_URLS } from "../../Common/Constant.js";
QuizShow.version = 1000;
QuizShow.lang = 'en';
QuizShow.langs = ['en'];
QuizShow.setLang = (lang: any) => {
    QuizShow.lang = lang;
};

Object.defineProperty(QuizShow, 'name', {
    writable: true,
    value: 'QuizShow'
});

// Define types
type FormState = { [key: string]: string[] };
type UserFormFields = { [key: string]: string };
type CAPTCHA = { num1: number; num2: number; answer: number; userAnswer: string };

export function QuizShow(props: any) {
    const [quizData, setQuizData] = useState<any>({});
    const [formState, setFormState] = useState<FormState>({});
    const [userFormFields, setUserFormFields] = useState<UserFormFields>({});
    const [captcha, setCaptcha] = useState<CAPTCHA | null>(null);
    const [formSubmitted, setFormSubmitted] = useState(false);
    const [finalScore, setFinalScore] = useState<number | null>(null);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [optionColors, setOptionColors] = useState<{ [key: string]: string }>({});
    const [validationErrors, setValidationErrors] = useState<string[]>([]);
    const endpoint = getEndpoint(props);
    const initialStateRef = useRef<FormState>({});
    const [questionNumberMapping, setQuestionNumberMapping] = useState<{ [key: string]: number }>({});

    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
        if (quizData && quizData.items && quizData.items[0] && quizData.items[0].it && quizData.items[0].it.primeId) {
            isLoggedIn();
        }
    }, [endpoint]);

    useEffect(() => {
        if (endpoint.isSSR && endpoint.SSRDataObj && Object.keys(quizData).length === 0) {
            setQuizData(endpoint.SSRDataObj);
            initializeFormState(endpoint.SSRDataObj);
            // if(endpoint.SSRDataObj.items && endpoint.SSRDataObj.items.length > 0) {
            //     setCmsSeoData(props, endpoint.SSRDataObj.items[0], "QuizShow");
            // }
        }
    }, [endpoint.SSRDataObj]);
    let requestId2: any = null;
    if (!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))) {
        let REQUEST_URL: any = null;
        if (props && props.REQUEST_URL) {
            REQUEST_URL = props.REQUEST_URL;
        }
        const idMatch = REQUEST_URL.match(/\/(\d+)\.html/);
        requestId2 = idMatch ? idMatch[1] : null;

    }
    let cdsDomain = '';
    if (typeof props.CONSTANTS.CDS_API !== "undefined") {
        cdsDomain = props.CONSTANTS.CDS_API;
    } else {
        cdsDomain = props.CONSTANTS.API_URL.CDS_API;
    }
    const fetchComponentData = () => {
        getData(getUrl(props, 1, false, 'MAIN', true));
    };

    const getData = (url: any) => {
        let headerString = '?' + url.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString };

        fetch(url, { headers: headers })
            .then((response) => response.json())
            .then(response => {
                setQuizData(response);
                initializeFormState(response);
                // if(response.items && response.items.length > 0) {
                //     setCmsSeoData(props, response.items[0], "QuizShow");
                // }
            })
            .catch(err => {
                //console.log("Exception => ", err);
            });
    };

    const initializeFormState = (data: any) => {
        const initialState: FormState = {};
        const questionMap: { [key: string]: number } = {};
        const responsePercentages: { [key: string]: number } = {};
        let questionNumber = 1;

        data?.responses?.forEach((response: any) => {
            responsePercentages[response.questionid] = response.percent;
        });

        data?.items?.[0]?.sections?.forEach((section: any) => {
            section?.questionpackages?.forEach((question: any) => {
                initialState[question.msid] = [];
                questionMap[question.msid] = questionNumber++;
            });
        });

        const userFormFields: UserFormFields = {};
        const userInfoDescriptor = data?.items?.[0]?.descriptor?.userinfo || [];

        userInfoDescriptor.forEach((info: any) => {
            if (info.required && info.info == "Location") {
                userFormFields[info.info] = 'demoLocation';
            }
        });
        userInfoDescriptor.forEach((info: any) => {
            if (info.required && info.info == "Name") {
                userFormFields[info.info] = 'demoName';
            }
        });
        userInfoDescriptor.forEach((info: any) => {
            if (info.required && info.info == "Age") {
                userFormFields[info.info] = 'demoAge';
            }
        });
        initialStateRef.current = initialState;
        setFormState(initialState);
        setUserFormFields(userFormFields);
        setQuestionNumberMapping(questionMap);
        generateCaptcha();
    };

    // const handleOptionChange = (questionId: string, optionId: string, isChecked: boolean) => {
    //     setFormState(prevState => {
    //         const selectedOptions = new Set(prevState[questionId]);
    //         if (isChecked) {
    //             selectedOptions.add(optionId);
    //         } else {
    //             selectedOptions.delete(optionId);
    //         }
    //         return { ...prevState, [questionId]: Array.from(selectedOptions) };
    //     });
    // };

    // test
    const handleOptionChange = (questionId: string, optionId: string, isChecked: boolean, multicorrect: boolean) => {
        setFormState(prevState => {
            const selectedOptions = new Set(prevState[questionId]);
            if (multicorrect) {
                // For multi-correct questions (checkbox), allow multiple selections
                if (isChecked) {
                    selectedOptions.add(optionId);
                } else {
                    selectedOptions.delete(optionId);
                }
            } else {
                // For single-correct questions (radio), clear previous selection
                if (isChecked) {
                    selectedOptions.clear();  // Clear previous selections
                    selectedOptions.add(optionId);  // Add the new selection
                }
            }

            return { ...prevState, [questionId]: Array.from(selectedOptions) };
        });
    };
    // test

    const generateClientId = () => {
        const timestamp = Date.now();
        const randomNum = Math.floor(Math.random() * 1000);
        return `${timestamp}-${randomNum}`;
    };

    const generateCaptcha = () => {
        const num1 = Math.floor(Math.random() * 10) + 1;
        const num2 = Math.floor(Math.random() * 10) + 1;
        const answer = num1 + num2;

        setCaptcha({
            num1,
            num2,
            answer,
            userAnswer: ''
        });
    };

    const handleCaptchaChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setCaptcha(prevCaptcha => ({
            ...prevCaptcha!,
            userAnswer: value
        }));
    };

    const validateCaptcha = () => {
        if (captcha) {
            return parseInt(captcha.userAnswer, 10) === captcha.answer;
        }
        return false;
    };

    const validateForm = () => {
        const errors: string[] = [];
        Object.keys(formState).forEach(questionId => {
            if (formState[questionId].length === 0) {
                const questionNo = questionNumberMapping[questionId];
                errors.push(`Question ${questionNo} has not been answered.`);
            }
        });

        setValidationErrors(errors);
        return errors.length === 0;
    };

    const calculateFinalScore = (data: any) => {
        const responses = data?.response?.responses;
        if (!Array.isArray(responses)) {
            console.error('Invalid responses data:', data);
            return 0;
        }

        const totalResponses = responses.length;
        const correctResponses = responses.filter((response: any) => response.percent === 100 && response.score > 0).length;
        const percentageScore = totalResponses > 0 ? (correctResponses / totalResponses) * 100 : 0;

        return percentageScore;
    };

    const handleSubmit = () => {
        const cookieValue = getCookie('quizTakenID');


        if (!validateCaptcha()) {
            setErrorMessage('Captcha answer is incorrect.');
            return;
        }
        if (!validateForm()) {
            return; // Stop submission if validation fails
        }

        if (!(typeof window !== 'undefined' && PAGEBUILDER_URLS.some(url => window.location.origin.includes(url)))) {
            if (cookieValue === requestId2) {
                setErrorMessage('You have already Participated');
                return
            }
        }
        const answers = Object.keys(formState).map(questionId => ({
            optionSelected: formState[questionId].map(option => String(option)), // Convert to string array
            questionId: Number(questionId)
        }));

        const payload = {
            answers: answers,
            endTime: Date.now(),
            hostId: props.clientHostId,
            quizForm: userFormFields,
            quizId: quizData?.items?.[0]?.id,
            startTime: 0,
            userIdentifier: {
                clientid: generateClientId()
            }
        };


        let headerString: string = JSON.stringify(payload);
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = { 'p-nonce': headerString, 'Content-Type': 'application/json' };
        fetch(`${cdsDomain}/cds-feed-ext/submit/quiz/m360`, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(payload)
        })
            .then(response => response.json())
            .then(result => {
                setCookie('quizTakenID', requestId2, 1); // Set cookie for 1 day
                setFormSubmitted(true);
                // Update option colors
                if (result?.response && Array.isArray(result.response.responses)) {
                    const colors: { [key: string]: string } = {};

                    result.response.responses.forEach((response: any) => {
                        const questionId = response.questionid;
                        const percent = response.percent;
                        const score = response.score;

                        response.options.forEach((optionId: string) => {
                            if (percent === 100 && score > 0) {
                                colors[`${questionId}_${optionId}`] = '#55AD50'; // Green for correct answer
                            } else if (percent === 0) {
                                colors[`${questionId}_${optionId}`] = '#E25A55'; // Red for incorrect answer
                            } else {
                                colors[`${questionId}_${optionId}`] = '#1F242933'; // Default for other options
                            }
                        });
                    });

                    setOptionColors(colors);
                }

                // Calculate the final score
                const score = calculateFinalScore(result);
                setFinalScore(score);
            })
            .catch(error => {
                console.error('Submission error:', error);
            });

        setErrorMessage('');
    };

    // const renderOptions = (options: any[], multicorrect: boolean, questionId: string) => {
    //     return options.map((option: any) => {
    //         const isSelected = formState[questionId]?.includes(option.id);
    //         const color = optionColors[`${questionId}_${option.id}`] || 'default-color';

    //         return (
    //             <div
    //                 key={option.id}
    //                 className={`radio-button-container ${isSelected ? 'selected' : ''}`}
    //                 style={{ backgroundColor: color }}
    //             >
    //                 <label>
    //                     <input
    //                         type={multicorrect ? 'checkbox' : 'radio'}
    //                         name={`question-${questionId}`}
    //                         value={option.id}
    //                         checked={isSelected}
    //                         onChange={(e) => handleOptionChange(questionId, option.id, e.target.checked)}
    //                     />
    //                     {option.option}
    //                 </label>
    //             </div>
    //         );
    //     });
    // };

    // test
    const renderOptions = (options: any[], multicorrect: boolean, questionId: string) => {
        return options.map((option: any) => {
            const isSelected = formState[questionId]?.includes(option.id);
            const color = optionColors[`${questionId}_${option.id}`] || 'default-color';

            return (
                <div
                    key={option.id}
                    className={`radio-button-container ${isSelected ? 'selected' : ''}`}
                    style={{ backgroundColor: color }}
                >
                    <label>
                        <input
                            type={multicorrect ? 'checkbox' : 'radio'}
                            name={`question-${questionId}`}
                            value={option.id}
                            checked={isSelected}
                            onChange={(e) => handleOptionChange(questionId, option.id, e.target.checked, multicorrect)}
                        />
                        {option.option}
                    </label>
                </div>
            );
        });
    };

    // test



    const renderImage = (msid: string, thumbsize: string) => {
        const imageUrl = getImageUrl(msid, thumbsize, 208, 156, "", false, props.CONSTANTS);

        if (imageUrl) {
            return (
                <img
                    src={imageUrl}
                    width="208"
                    height="156"
                    alt="Question Thumbnail"
                    style={{ display: 'block' }}
                />
            );
        }

        return null;
    };

    const renderQuiz = () => {
        if (Object.keys(quizData).length === 0) {
            return <div>Loading...</div>;
        }

        return quizData.items[0].sections.map((section: any) => (
            <div className='ThemeThreeQuizQuestionAnswerWrap' key={section.msid}>
                {/* <h2 className='ThemeThreeSectionTitleWrap'>{section.title}</h2> */}
                {section.questionpackages.map((question: any, index: any) => (
                    <div className='ThemeThreeQuizMainQuestionWrap' key={question.msid}>
                        <h3 className='ThemeThreeQuizTitleQuestionWrap'>{(index + 1)} :{question.title} {question.required && <span style={{ color: 'red' }}>*</span>}
                        </h3>
                        <div className='ThemeThreeQuizTitleQuestionInnerWrap'>
                            <div className='ThemeThreeQuizTitleAnswerInnerWrap'> {renderOptions(question.options, question.multicorrect, question.msid)}</div>
                            <div className='ThemeThreeQuizTitleImageInnerWrap'>{question?.thumbsize ? renderImage(question.msid, question.thumbsize) : ''}</div>
                        </div>
                    </div>
                ))}
            </div>
        ));
    };


    const getRenderPart = () => {
        return (
            <CacheProvider value={getMUICache()}>
                <div className='story-wrapper'>
                    <div className="ThemeThreeQuizeHeadingWrap">
                        <div className='ThemeThreeQuizeImageWrap'>
                            {<img src={getImageUrl(quizData?.items?.[0]?.id, getImageSize(quizData?.items?.[0]?.imageid), 143, 108, "", false, props.CONSTANTS)} width="145" height="100" alt="Quiz Thumbnail" />}
                        </div>
                        <div className='ThemeThreeQuizeShowHeadingWrapper'>
                            <h1 className="ThemeThreeQuizeShowHeading" dangerouslySetInnerHTML={{ __html: quizData?.items?.[0]?.hl }}></h1>
                            <div className='ThemeThreeQuizeAuthorWrap'>{convertEpochTime(quizData?.items?.[0]?.lpt, 'updated', "DD MMM YYYY")} - {quizData?.items?.[0]?.authors?.[0].name} - {quizData?.items?.ag}</div>
                            <div className='ThemeThreeQuizeDataWrap' dangerouslySetInnerHTML={{ __html: quizData?.items?.[0]?.syn }}></div>
                        </div>
                    </div>
                </div>
            </CacheProvider>
        );
    };

    return (
        <CacheProvider value={getMUICache()}>
            <Box p={2}>
                <div className='ThemeThreeOutherWrapperMainWrapper'>
                    {getRenderPart()}
                    {renderQuiz()}
                    {captcha && !formSubmitted && (
                        <div className='ThemeThreeQuizeQustionWrap'>
                            <p>What is {captcha.num1} + {captcha.num2}?</p>
                            <input
                                type="text"
                                value={captcha.userAnswer}
                                onChange={handleCaptchaChange}
                            />
                        </div>
                    )}
                    {!formSubmitted && <button className='QuizSubmitButton' onClick={handleSubmit}>Submit</button>}
                    {formSubmitted && finalScore !== null && (
                        <div className='ThemeThreeScoreWrap'>
                            <p className='ThemeThreeSubmitMessage'>Thank You For Your Submission</p>
                            <p className='ThemeThreeSubmitScore'>Your Score: {Math.round(finalScore)}%</p>
                        </div>
                    )}
                    {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                    {validationErrors.length > 0 && (
                        <div style={{ color: 'red' }} className='ThemeThreeErrorWrap'>
                            {validationErrors.map((error, index) => (
                                <p key={index}>{error}</p>
                            ))}
                        </div>
                    )}
                </div>
                <div className='QuizSurvetWrapper'>
                    <p className='disclaimerQuizSurvey'>DISCLAIMER:</p>
                    <ul>
                        <li>Questions marked with red asterisk (*) are mandatory to answer </li>
                        <li>Legal information is not legal advice, read the disclaimer. The information provided on this site is not legal advice, does not constitute a lawyer referral service, and no attorney-client or confidential relationship is or will be formed by use of the site.</li>
                    </ul>
                </div>
            </Box>
        </CacheProvider>
    );
}
